module.exports = __webpack_public_path__ + "static/media/subscribe.ca227c72.jpg";